import sum from 'lodash/sum';
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
import { devServer, devServer_somee } from '../globalSettings';
import { SERVER_API } from '../../config-global';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  formTypes: [],
  eventStatus: [],
  getPreFormSuccess: [],
  CAFId: null,
  insertPreFormSectionBSuccess: [],
  insertPreFormSectionCSuccess: [],
  insertPreFormSectionDSuccess: [],
  insertPreFormSectionESuccess: [],
  insertPreFormSectionFSuccess: [],
  insertPreFormSectionGSuccess: [],
  insertPreFormSectionHSuccess: [],
  insertPreFormAcknowledgementSuccess: [],
  VIEEligibilityCheckList:[],
  VIEEligibilityRespone:[],
  PreviusVIEEligibilityRespone:[]
};

const slice = createSlice({
  name: 'formStructure',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET CONFERENCE EVENTS
    getFormTypes(state, action) {
      state.isLoading = false;
      state.formTypes = action.payload;
    },

    // GET CONFERENCE EVENTS
    getEventStatusSuccess(state, action) {
      state.isLoading = false;
      state.eventStatus = action.payload;
    },

    getPreformSuccess(state, action) {
      state.isLoading = false;
      state.getPreFormSuccess = action.payload;
      console.log('Reducer - getPreFormSuccess updated:', action.payload);
    },

    // GET CONFERENCE EVENTS
    insertPreFormSectionASuccess(state, action) {
      console.log('insertPreFormSectionASuccess', action.payload);
      state.isLoading = false;
      state.CAFId = action.payload;
    },

    insertPreFormSectionB(state, action) {
      state.isLoading = false;
      state.insertPreFormSectionBSuccess = action.payload;
    },

    insertPreFormSectionC(state, action) {
      state.isLoading = false;
      state.insertPreFormSectionCSuccess = action.payload;
    },

    insertPreFormSectionD(state, action) {
      state.isLoading = false;
      state.insertPreFormSectionDSuccess = action.payload;
    },

    insertPreFormSectionE(state, action) {
      state.isLoading = false;
      state.insertPreFormSectionESuccess = action.payload;
    },

    insertPreFormSectionF(state, action) {
      state.isLoading = false;
      state.insertPreFormSectionFSuccess = action.payload;
    },

    insertPreFormSectionG(state, action) {
      state.isLoading = false;
      state.insertPreFormSectionGSuccess = action.payload;
    },

    insertPreFormAcknowledgement(state, action) {
      state.isLoading = false;
      state.insertPreFormAcknowledgementSuccess = action.payload;
    },
    User_SelectAllQuestionFromVIEEligibilityCheckListSuccess(state, action) {
      state.isLoading = false;
      state.VIEEligibilityCheckList = action.payload;
    },
    Admin_InsertVIEEligibilityCheckListResponeIDSuccess(state, action) {
      state.isLoading = false;
      state.VIEEligibilityCheckListResponeID = action.payload;
    },
    Admin_SelectAllResponceFromVIEEligibilityByEventIDSuccess(state, action) {
      state.isLoading = false;
      state.PreviusVIEEligibilityRespone = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { getFormTypes } = slice.actions;

// ----------------------------------------------------------------------

export function fetchFormTypes() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${devServer}General_ViewAnswerType`);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      console.log(data);
      if (data && data.ReturnVal === 1) {
        dispatch(slice.actions.getFormTypes(JSON.parse(data.ReturnData)));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getEventStatus() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}SelectEventStatus`);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      console.log('ssss', data, json);
      if (data && data.ReturnVal === 1) {
        dispatch(slice.actions.getEventStatusSuccess(JSON.parse(data.ReturnData)));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPreform() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}SelectPreform`);
      const json = await response.json();
      const data = JSON.parse(json)[0];

      if (data && data.ReturnVal === 1) {
        dispatch(slice.actions.getPreformSuccess(JSON.parse(data.ReturnData)));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function insertPreFormSectionA(insert_data, PFID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const requestUrl = `${SERVER_API}InsertIntoPreFormSectionA?PFapplicantName=${encodeURIComponent(
        insert_data.PFapplicantName
      )}&PFprefix=${encodeURIComponent(insert_data.PFprefix)}&PFdesignation=${encodeURIComponent(
        insert_data.PFdesignation
      )}&PForganisationName=${encodeURIComponent(
        insert_data.PForganisationName
      )}&PFregisteredOrganisationAddress=${encodeURIComponent(
        insert_data.PFregisteredOrganisationAddress
      )}&PFmailingAddress=${encodeURIComponent(
        insert_data.PFmailingAddress
      )}&PForganisationTelephone=${encodeURIComponent(
        insert_data.PForganisationTelephone
      )}&PForganisationFax=${encodeURIComponent(
        insert_data.PForganisationFax
      )}&PForganisationMobileNo=${encodeURIComponent(
        insert_data.PForganisationMobileNo
      )}&PForganisationEmail=${encodeURIComponent(
        insert_data.PForganisationEmail
      )}&PForganisationSocialMediaAccount=${encodeURIComponent(
        insert_data.PForganisationSocialMediaAccount
      )}&PForganisationWebsite=${encodeURIComponent(
        insert_data.PForganisationWebsite
      )}&PFauthorisedProfile=${encodeURIComponent(
        insert_data.PFauthorisedProfile
      )}&PForganisationProfile=${encodeURIComponent(
        insert_data.PForganisationProfile
      )}&InsertedID=${PFID}`;
      const response = await fetch(requestUrl);
      const json = await response.json();
      const data = JSON.parse(json)[0];
      const InsertedIDAfterJSON = JSON.parse(data.ReturnData)[0].InsertedID;
      if (data.ReturnVal === 1) {
        dispatch(slice.actions.insertPreFormSectionASuccess(InsertedIDAfterJSON));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function insertPreFormSectionB(data, PFID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    console.log('sectionBBack', PFID);
    try {
      const requestUrl = `${SERVER_API}InsertIntoPreFormSectionB?PFaffiliatedOrganisationName=${encodeURIComponent(
        data.PFaffiliatedOrganisationName
      )}&PFaffiliatedContactPerson=${encodeURIComponent(
        data.PFaffiliatedContactPerson
      )}&PFaffiliatedPosition=${encodeURIComponent(
        data.PFaffiliatedPosition
      )}&PFaffiliatedAddress=${encodeURIComponent(
        data.PFaffiliatedAddress
      )}&PFaffiliatedTelephone=${encodeURIComponent(
        data.PFaffiliatedTelephone
      )}&PFaffiliatedFax=${encodeURIComponent(
        data.PFaffiliatedFax
      )}&PFaffiliatedEmail=${encodeURIComponent(
        data.PFaffiliatedEmail
      )}&PFaffiliatedWebsite=${encodeURIComponent(data.PFaffiliatedWebsite)}&InsertedID=${PFID}`;
      console.log('Request URL:', requestUrl);
      const response = await fetch(requestUrl);
      const result = await response.json();

      if (result.ReturnVal === 1) {
        dispatch(slice.actions.insertPreFormSectionBSuccess(result.ReturnData));
        return result.ReturnData;
      }

      dispatch(slice.actions.hasError(result.ReturnMsg));
      return null;
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
      return null;
    }
  };
}

export function insertPreFormSectionC(data, PFID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    console.log('sectionCBack', PFID);
    try {
      const requestUrl = `${SERVER_API}InsertIntoPreFormSectionC?PFfullNameOfEvent=${data.PFfullNameOfEvent}&PFeventAcronym=${data.PFeventAcronym}&PFsupportingAgency=${data.PFsupportingAgency}&PFtopic=${data.PFtopic}&PFcategory=${data.PFcategory}&PFtype=${data.PFtype}&PFedition=${data.PFedition}&PFsegment=${data.PFsegment}&PFfrequency=${data.PFfrequency}&PFpattern=${data.PFpattern}&PFformat=${data.PFformat}&PFstartDate=${data.PFstartDate}&PFendDate=${data.PFendDate}&PFduration=${data.PFduration}&PFlocation=${data.PFlocation}&PFvenue=${data.PFvenue}&InsertedID=${PFID}`;
      console.log('Request URL:', requestUrl);
      const response = await fetch(requestUrl);
      const result = await response.json();

      if (result.ReturnVal === 1) {
        dispatch(slice.actions.insertPreFormSectionCSuccess(result.ReturnData));
        return result.ReturnData;
      }

      dispatch(slice.actions.hasError(result.ReturnMsg));
      return null;
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
      return null;
    }
  };
}

export function insertPreFormSectionD(data, PFID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    console.log('sectionDBack', PFID);
    try {
      const requestUrl = `${SERVER_API}InsertIntoPreFormSectionD?PFexhSarawak=${data.PFexhSarawak}&PFexhROM=${data.PFexhROM}&PFexhInternational=${data.PFexhInternational}&PFexhTotal=${data.PFexhTotal}&PFexhExhibitorsSarawak=${data.PFexhExhibitorsSarawak}&PFexhExhibitorsROM=${data.PFexhExhibitorsROM}&PFexhExhibitorsInternational=${data.PFexhExhibitorsInternational}&PFexhExhibitorsTotal=${data.PFexhExhibitorsTotal}&PFexhBoothsSarawak=${data.PFexhBoothsSarawak}&PFexhBoothsROM=${data.PFexhBoothsROM}&PFexhBoothsInternational=${data.PFexhBoothsInternational}&PFexhBoothsTotal=${data.PFexhBoothsTotal}&PFexhVisitorsSarawak=${data.PFexhVisitorsSarawak}&PFexhVisitorsROM=${data.PFexhVisitorsROM}&PFexhVisitorsInternational=${data.PFexhVisitorsInternational}&PFexhVisitorsTotal=${data.PFexhVisitorsTotal}&PFattendeeCategories=${data.PFattendeeCategories}&PFScategory=${data.PFScategory}&PFfee=${data.PFfee}&PFteiTotal=${data.PFteiTotal}&PFteiDDE=${data.PFteiDDE}&PFteiTaxRev=${data.PFteiTaxRev}&PFteiEmpOpp=${data.PFteiEmpOpp}&InsertedID=${PFID}`;
      console.log('Request URL:', requestUrl);
      const response = await fetch(requestUrl);
      const result = await response.json();

      if (result.ReturnVal === 1) {
        dispatch(slice.actions.insertPreFormSectionDSuccess(result.ReturnData));
        return result.ReturnData;
      }

      dispatch(slice.actions.hasError(result.ReturnMsg));
      return null;
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
      return null;
    }
  };
}

export function insertPreFormSectionE(data, PFID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    console.log('sectionEBack', PFID);
    try {
      const requestUrl = `${SERVER_API}InsertIntoPreFormSectionE?PFsummary=${data.PFsummary}&PFaimsAndObjectives=${data.PFaimsAndObjectives}&PFknowledgeExpansion=${data.PFknowledgeExpansion}&PFraisingAwareness=${data.PFraisingAwareness}&PFfundraising=${data.PFfundraising}&PFfutureOpportunity=${data.PFfutureOpportunity}&PFnetworkCollaboration=${data.PFnetworkCollaboration}&PFeducationOutcome=${data.PFeducationOutcome}&PFsponsorShip=${data.PFsponsorShip}&PFhistoryEvent1Date=${data.PFhistoryEvent1Date}&PFhistoryEvent1City=${data.PFhistoryEvent1City}&PFhistoryEvent1DelNo=${data.PFhistoryEvent1DelNo}&PFhistoryEvent1RegFee=${data.PFhistoryEvent1RegFee}&PFhistoryEvent2Date=${data.PFhistoryEvent2Date}&PFhistoryEvent2City=${data.PFhistoryEven2tCity}&PFhistoryEvent2DelNo=${data.PFhistoryEvent2DelNo}&PFhistoryEvent2RegFee=${data.PFhistoryEvent2RegFee}&InsertedID=${PFID}`;
      console.log('Request URL:', requestUrl);
      const response = await fetch(requestUrl);
      const result = await response.json();

      if (result.ReturnVal === 1) {
        dispatch(slice.actions.insertPreFormSectionESuccess(result.ReturnData));
        return result.ReturnData;
      }

      dispatch(slice.actions.hasError(result.ReturnMsg));
      return null;
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
      return null;
    }
  };
}

export function insertPreFormSectionF(data, PFID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    console.log('sectionFBack', PFID);
    try {
      const requestUrl = `${SERVER_API}InsertIntoPreFormSectionF?PFbidProDesFactorBidSubmission=${data.PFbidProDesFactorBidSubmission}&PFbidProDesFactorComDecision=${data.PFbidProDesFactorComDecision}&PFbidProDesFactorIndividual=${data.PFbidProDesFactorIndividual}&PFbidProDesFactorBidAutoSwk=${data.PFbidProDesFactorBidAutoSwk}&PFbidProDesFactorBidRotation=${data.PFbidProDesFactorBidRotation}&PFbidProDesFactorVoteDel=${data.PFbidProDesFactorVoteDel}&PFbidProDesFactorOthers=${data.PFbidProDesFactorOthers}&PFbidProHostedDate=${data.PFbidProHostedDate}&PFbidProHostedOthMysDate=${data.PFbidProHostedOthMysDate}&PFbidProCompetitor=${data.PFbidProCompetitor}&PFsubsidybreakEven=${data.PFsubsidybreakEven}&PFgenerateReturn=${data.PFgenerateReturn}&InsertedID=${PFID}`;
      console.log('Request URL:', requestUrl);
      const response = await fetch(requestUrl);
      const result = await response.json();

      if (result.ReturnVal === 1) {
        dispatch(slice.actions.insertPreFormSectionFSuccess(result.ReturnData));
        return result.ReturnData;
      }

      dispatch(slice.actions.hasError(result.ReturnMsg));
      return null;
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
      return null;
    }
  };
}

export function insertPreFormSectionG(data, PFID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    console.log('sectionGBack', PFID);
    try {
      const requestUrl = `${SERVER_API}InsertIntoPreFormSectionG?PFserviceAcquired=${data.PFserviceAcquired}&PFcapabilitiesAndExperience=${data.PFcapabilitiesAndExperience}&PFcontactPerson=${data.PFcontactPerson}&PFcompanyName=${data.PFcompanyName}&PFregistrationNumber=${data.PFregistrationNumber}&PFofficeAddress=${data.PFofficeAddress}&PFcontactTelephoneNum=${data.PFcontactTelephoneNum}&PFcontactFacsimile=${data.PFcontactFacsimile}&PFcontactEmail=${data.PFcontactEmail}&PFcontactWebsite=${data.PFcontactWebsite}&PFserviceEngaged=${data.PFserviceEngaged}&PFserviceAcquired2=${data.PFserviceAcquired2}&PFcapabilitiesAndExperience2=${data.PFcapabilitiesAndExperience2}&PFcontactPerson2=${data.PFcontactPerson2}&PFcompanyName2=${data.PFcompanyName2}&PFregistrationNumber2=${data.PFregistrationNumber2}&PFofficeAddress2=${data.PFofficeAddress2}&PFcontactTelephoneNum2=${data.PFcontactTelephoneNum2}&PFcontactFacsimile2=${data.PFcontactFacsimile2}&PFcontactEmail2=${data.PFcontactEmail2}&PFcontactWebsite2=${data.PFcontactWebsite2}&PFserviceEngaged2=${data.PFserviceEngaged2}&InsertedID=${PFID}`;
      console.log('Request URL:', requestUrl);
      const response = await fetch(requestUrl);
      const result = await response.json();

      if (result.ReturnVal === 1) {
        dispatch(slice.actions.insertPreFormSectionGSuccess(result.ReturnData));
        return result.ReturnData;
      }

      dispatch(slice.actions.hasError(result.ReturnMsg));
      return null;
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
      return null;
    }
  };
}

export function insertPreFormSectionH(data, PFID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    console.log('sectionHBack', PFID);
    try {
      const requestUrl = `${SERVER_API}InsertIntoPreFormSectionH?PFchecklistDocbusinessRegistrationCertificate=${data.PFchecklistDocbusinessRegistrationCertificate}&PFchecklistDoclatestCompanyProfile=${data.PFchecklistDoclatestCompanyProfile}&PFchecklistDocEventProposal=${data.PFchecklistDocEventProposal}&PFchecklistDocProfileBackground=${data.PFchecklistDocProfileBackground}&InsertedID=${PFID}`;
      console.log('Request URL:', requestUrl);
      const response = await fetch(requestUrl);
      const result = await response.json();

      if (result.ReturnVal === 1) {
        dispatch(slice.actions.insertPreFormSectionHSuccess(result.ReturnData));
        return result.ReturnData;
      }

      dispatch(slice.actions.hasError(result.ReturnMsg));
      return null;
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
      return null;
    }
  };
}

export function insertPreFormAcknowledgement(data, PFID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    console.log('sinsertPreFormAcknowledgementBack', PFID);
    try {
      const requestUrl = `${SERVER_API}InsertIntoPreFormAcknowledgement?PFchecklistDoc=${data.PFchecklistDoc}&PFacknowledgementIc=${data.PFacknowledgementIc}&PFacknowledgementOrganistion=${data.PFacknowledgementOrganistion}&PFacknowledgementDestination=${data.PFacknowledgementDestination}&PFacknowledgementDate=${data.PFacknowledgementDate}&InsertedID=${PFID}`;
      console.log('Request URL:', requestUrl);
      const response = await fetch(requestUrl);
      const result = await response.json();

      if (result.ReturnVal === 1) {
        dispatch(slice.actions.insertPreFormAcknowledgementSuccess(result.ReturnData));
        return result.ReturnData;
      }

      dispatch(slice.actions.hasError(result.ReturnMsg));
      return null;
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
      return null;
    }
  };
}

export function User_SelectAllQuestionFromVIEEligibilityCheckList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}User_SelectAllQuestionFromVIEEligibilityCheckList`);
      const json = await response.json();
      const data = JSON.parse(json)[0];

      if (data && data.ReturnVal === 1) {
        dispatch(slice.actions.User_SelectAllQuestionFromVIEEligibilityCheckListSuccess(JSON.parse(data.ReturnData)));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function Admin_InsertVIEEligibilityCheckListResponeID(updateData, VIEEligibilityCheckListResponeID, eventID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      console.log('hello there', {
        nameOfResponceOfVIECriteria: updateData.nameOfResponceOfVIECriteria,
        positionOfResponceOfVIECriteria: updateData.positionOfResponceOfVIECriteria,
        emailOfResponceOfVIECriteria: updateData.emailOfResponceOfVIECriteria,
        dateOfResponceOfVIECriteria: updateData.dateOfResponceOfVIECriteria,
        issuesInResponceOfVIECriteria: updateData.issuesInResponceOfVIECriteria,
        overallEligibility: updateData.overallEligibility,


        VIEEligibilityCheckList_1_1_criteriaMet: updateData.VIEEligibilityCheckList_1_1_criteriaMet,
        VIEEligibilityCheckList_1_1_remarks: updateData.VIEEligibilityCheckList_1_1_remarks,
        VIEEligibilityCheckList_1_2_criteriaMet: updateData.VIEEligibilityCheckList_1_2_criteriaMet,
        VIEEligibilityCheckList_1_2_remarks: updateData.VIEEligibilityCheckList_1_2_remarks,
        VIEEligibilityCheckList_1_3_criteriaMet: updateData.VIEEligibilityCheckList_1_3_criteriaMet,
        VIEEligibilityCheckList_1_3_remarks: updateData.VIEEligibilityCheckList_1_3_remarks,
        VIEEligibilityCheckList_1_4_criteriaMet: updateData.VIEEligibilityCheckList_1_4_criteriaMet,
        VIEEligibilityCheckList_1_4_remarks: updateData.VIEEligibilityCheckList_1_4_remarks,
        VIEEligibilityCheckList_1_5_criteriaMet: updateData.VIEEligibilityCheckList_1_5_criteriaMet,
        VIEEligibilityCheckList_1_5_remarks: updateData.VIEEligibilityCheckList_1_5_remarks,

        VIEEligibilityCheckList_2_1_criteriaMet: updateData.VIEEligibilityCheckList_2_1_criteriaMet,
        VIEEligibilityCheckList_2_1_remarks: updateData.VIEEligibilityCheckList_2_1_remarks,
        VIEEligibilityCheckList_2_2_criteriaMet: updateData.VIEEligibilityCheckList_2_2_criteriaMet,
        VIEEligibilityCheckList_2_2_remarks: updateData.VIEEligibilityCheckList_2_2_remarks,
        VIEEligibilityCheckList_2_3_criteriaMet: updateData.VIEEligibilityCheckList_2_3_criteriaMet,
        VIEEligibilityCheckList_2_3_remarks: updateData.VIEEligibilityCheckList_2_3_remarks,
        VIEEligibilityCheckList_2_4_criteriaMet: updateData.VIEEligibilityCheckList_2_4_criteriaMet,
        VIEEligibilityCheckList_2_4_remarks: updateData.VIEEligibilityCheckList_2_4_remarks,
        VIEEligibilityCheckList_2_5_criteriaMet: updateData.VIEEligibilityCheckList_2_5_criteriaMet,
        VIEEligibilityCheckList_2_5_remarks: updateData.VIEEligibilityCheckList_2_5_remarks,
        VIEEligibilityCheckList_2_6_criteriaMet: updateData.VIEEligibilityCheckList_2_6_criteriaMet,
        VIEEligibilityCheckList_2_6_remarks: updateData.VIEEligibilityCheckList_2_6_remarks,
        VIEEligibilityCheckList_2_7_criteriaMet: updateData.VIEEligibilityCheckList_2_7_criteriaMet,
        VIEEligibilityCheckList_2_7_remarks: updateData.VIEEligibilityCheckList_2_7_remarks,

        VIEEligibilityCheckList_3_1_criteriaMet: updateData.VIEEligibilityCheckList_3_1_criteriaMet,
        VIEEligibilityCheckList_3_1_remarks: updateData.VIEEligibilityCheckList_3_1_remarks,
        VIEEligibilityCheckList_3_2_criteriaMet: updateData.VIEEligibilityCheckList_3_2_criteriaMet,
        VIEEligibilityCheckList_3_2_remarks: updateData.VIEEligibilityCheckList_3_2_remarks,
        VIEEligibilityCheckList_3_3_criteriaMet: updateData.VIEEligibilityCheckList_3_3_criteriaMet,
        VIEEligibilityCheckList_3_3_remarks: updateData.VIEEligibilityCheckList_3_3_remarks,
        VIEEligibilityCheckList_3_4_criteriaMet: updateData.VIEEligibilityCheckList_3_4_criteriaMet,
        VIEEligibilityCheckList_3_4_remarks: updateData.VIEEligibilityCheckList_3_4_remarks,

        VIEEligibilityCheckList_4_1_criteriaMet: updateData.VIEEligibilityCheckList_4_1_criteriaMet,
        VIEEligibilityCheckList_4_1_remarks: updateData.VIEEligibilityCheckList_4_1_remarks,
        VIEEligibilityCheckList_4_2_criteriaMet: updateData.VIEEligibilityCheckList_4_2_criteriaMet,
        VIEEligibilityCheckList_4_2_remarks: updateData.VIEEligibilityCheckList_4_2_remarks,
        VIEEligibilityCheckList_4_3_criteriaMet: updateData.VIEEligibilityCheckList_4_3_criteriaMet,
        VIEEligibilityCheckList_4_3_remarks: updateData.VIEEligibilityCheckList_4_3_remarks,
        VIEEligibilityCheckList_4_4_criteriaMet: updateData.VIEEligibilityCheckList_4_4_criteriaMet,
        VIEEligibilityCheckList_4_4_remarks: updateData.VIEEligibilityCheckList_4_4_remarks,
        VIEEligibilityCheckList_4_5_criteriaMet: updateData.VIEEligibilityCheckList_4_5_criteriaMet,
        VIEEligibilityCheckList_4_5_remarks: updateData.VIEEligibilityCheckList_4_5_remarks,

        VIEEligibilityCheckList_5_1_criteriaMet: updateData.VIEEligibilityCheckList_5_1_criteriaMet,
        VIEEligibilityCheckList_5_1_remarks: updateData.VIEEligibilityCheckList_5_1_remarks,
        VIEEligibilityCheckList_5_2_criteriaMet: updateData.VIEEligibilityCheckList_5_2_criteriaMet,
        VIEEligibilityCheckList_5_2_remarks: updateData.VIEEligibilityCheckList_5_2_remarks,
        VIEEligibilityCheckList_5_3_criteriaMet: updateData.VIEEligibilityCheckList_5_3_criteriaMet,
        VIEEligibilityCheckList_5_3_remarks: updateData.VIEEligibilityCheckList_5_3_remarks,
        VIEEligibilityCheckList_5_4_criteriaMet: updateData.VIEEligibilityCheckList_5_4_criteriaMet,
        VIEEligibilityCheckList_5_4_remarks: updateData.VIEEligibilityCheckList_5_4_remarks,

        VIEEligibilityCheckListResponeID,
        eventID
      })

      const response = await fetch(`${SERVER_API}Admin_InsertVIEEligibilityCheckListResponeID`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          nameOfResponceOfVIECriteria: updateData.nameOfResponceOfVIECriteria,
          positionOfResponceOfVIECriteria: updateData.positionOfResponceOfVIECriteria,
          emailOfResponceOfVIECriteria: updateData.emailOfResponceOfVIECriteria,
          dateOfResponceOfVIECriteria: updateData.dateOfResponceOfVIECriteria,
          issuesInResponceOfVIECriteria: updateData.issuesInResponceOfVIECriteria,
          overallEligibility: updateData.overallEligibility,


          VIEEligibilityCheckList_1_1_criteriaMet: updateData.VIEEligibilityCheckList_1_1_criteriaMet,
          VIEEligibilityCheckList_1_1_remarks: updateData.VIEEligibilityCheckList_1_1_remarks,
          VIEEligibilityCheckList_1_2_criteriaMet: updateData.VIEEligibilityCheckList_1_2_criteriaMet,
          VIEEligibilityCheckList_1_2_remarks: updateData.VIEEligibilityCheckList_1_2_remarks,
          VIEEligibilityCheckList_1_3_criteriaMet: updateData.VIEEligibilityCheckList_1_3_criteriaMet,
          VIEEligibilityCheckList_1_3_remarks: updateData.VIEEligibilityCheckList_1_3_remarks,
          VIEEligibilityCheckList_1_4_criteriaMet: updateData.VIEEligibilityCheckList_1_4_criteriaMet,
          VIEEligibilityCheckList_1_4_remarks: updateData.VIEEligibilityCheckList_1_4_remarks,
          VIEEligibilityCheckList_1_5_criteriaMet: updateData.VIEEligibilityCheckList_1_5_criteriaMet,
          VIEEligibilityCheckList_1_5_remarks: updateData.VIEEligibilityCheckList_1_5_remarks,
          VIEEligibilityCheckList_1_6_criteriaMet: updateData.VIEEligibilityCheckList_1_6_criteriaMet,
          VIEEligibilityCheckList_1_6_remarks: updateData.VIEEligibilityCheckList_1_6_remarks,

          VIEEligibilityCheckList_2_1_criteriaMet: updateData.VIEEligibilityCheckList_2_1_criteriaMet,
          VIEEligibilityCheckList_2_1_remarks: updateData.VIEEligibilityCheckList_2_1_remarks,
          VIEEligibilityCheckList_2_2_criteriaMet: updateData.VIEEligibilityCheckList_2_2_criteriaMet,
          VIEEligibilityCheckList_2_2_remarks: updateData.VIEEligibilityCheckList_2_2_remarks,
          VIEEligibilityCheckList_2_3_criteriaMet: updateData.VIEEligibilityCheckList_2_3_criteriaMet,
          VIEEligibilityCheckList_2_3_remarks: updateData.VIEEligibilityCheckList_2_3_remarks,
          VIEEligibilityCheckList_2_4_criteriaMet: updateData.VIEEligibilityCheckList_2_4_criteriaMet,
          VIEEligibilityCheckList_2_4_remarks: updateData.VIEEligibilityCheckList_2_4_remarks,
          VIEEligibilityCheckList_2_5_criteriaMet: updateData.VIEEligibilityCheckList_2_5_criteriaMet,
          VIEEligibilityCheckList_2_5_remarks: updateData.VIEEligibilityCheckList_2_5_remarks,
          VIEEligibilityCheckList_2_6_criteriaMet: updateData.VIEEligibilityCheckList_2_6_criteriaMet,
          VIEEligibilityCheckList_2_6_remarks: updateData.VIEEligibilityCheckList_2_6_remarks,
          VIEEligibilityCheckList_2_7_criteriaMet: updateData.VIEEligibilityCheckList_2_7_criteriaMet,
          VIEEligibilityCheckList_2_7_remarks: updateData.VIEEligibilityCheckList_2_7_remarks,

          VIEEligibilityCheckList_3_1_criteriaMet: updateData.VIEEligibilityCheckList_3_1_criteriaMet,
          VIEEligibilityCheckList_3_1_remarks: updateData.VIEEligibilityCheckList_3_1_remarks,
          VIEEligibilityCheckList_3_2_criteriaMet: updateData.VIEEligibilityCheckList_3_2_criteriaMet,
          VIEEligibilityCheckList_3_2_remarks: updateData.VIEEligibilityCheckList_3_2_remarks,
          VIEEligibilityCheckList_3_3_criteriaMet: updateData.VIEEligibilityCheckList_3_3_criteriaMet,
          VIEEligibilityCheckList_3_3_remarks: updateData.VIEEligibilityCheckList_3_3_remarks,
          VIEEligibilityCheckList_3_4_criteriaMet: updateData.VIEEligibilityCheckList_3_4_criteriaMet,
          VIEEligibilityCheckList_3_4_remarks: updateData.VIEEligibilityCheckList_3_4_remarks,

          VIEEligibilityCheckList_4_1_criteriaMet: updateData.VIEEligibilityCheckList_4_1_criteriaMet,
          VIEEligibilityCheckList_4_1_remarks: updateData.VIEEligibilityCheckList_4_1_remarks,
          VIEEligibilityCheckList_4_2_criteriaMet: updateData.VIEEligibilityCheckList_4_2_criteriaMet,
          VIEEligibilityCheckList_4_2_remarks: updateData.VIEEligibilityCheckList_4_2_remarks,
          VIEEligibilityCheckList_4_3_criteriaMet: updateData.VIEEligibilityCheckList_4_3_criteriaMet,
          VIEEligibilityCheckList_4_3_remarks: updateData.VIEEligibilityCheckList_4_3_remarks,
          VIEEligibilityCheckList_4_4_criteriaMet: updateData.VIEEligibilityCheckList_4_4_criteriaMet,
          VIEEligibilityCheckList_4_4_remarks: updateData.VIEEligibilityCheckList_4_4_remarks,
          VIEEligibilityCheckList_4_5_criteriaMet: updateData.VIEEligibilityCheckList_4_5_criteriaMet,
          VIEEligibilityCheckList_4_5_remarks: updateData.VIEEligibilityCheckList_4_5_remarks,

          VIEEligibilityCheckList_5_1_criteriaMet: updateData.VIEEligibilityCheckList_5_1_criteriaMet,
          VIEEligibilityCheckList_5_1_remarks: updateData.VIEEligibilityCheckList_5_1_remarks,
          VIEEligibilityCheckList_5_2_criteriaMet: updateData.VIEEligibilityCheckList_5_2_criteriaMet,
          VIEEligibilityCheckList_5_2_remarks: updateData.VIEEligibilityCheckList_5_2_remarks,
          VIEEligibilityCheckList_5_3_criteriaMet: updateData.VIEEligibilityCheckList_5_3_criteriaMet,
          VIEEligibilityCheckList_5_3_remarks: updateData.VIEEligibilityCheckList_5_3_remarks,
          VIEEligibilityCheckList_5_4_criteriaMet: updateData.VIEEligibilityCheckList_5_4_criteriaMet,
          VIEEligibilityCheckList_5_4_remarks: updateData.VIEEligibilityCheckList_5_4_remarks,

          VIEEligibilityCheckListResponeID,
          eventID
        })
      });

      const result = await response.json();
      const data = result[0];
      console.log("result",result)
      if (data && data.ReturnVal === 1) {
        const InsertedIDAfterJSON = JSON.parse(data.ReturnData)[0].VIEEligibilityCheckListResponeID;

        console.log(InsertedIDAfterJSON)
     
        dispatch(slice.actions.Admin_InsertVIEEligibilityCheckListResponeIDSuccess(InsertedIDAfterJSON));
      } else {
        dispatch(slice.actions.hasError(result.ReturnMsg));
      }
    } catch (error) {
      console.log("error",error)
      dispatch(slice.actions.hasError(error));
    }
  };
}



export function Admin_SelectAllResponceFromVIEEligibilityByEventID(eventID) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await fetch(`${SERVER_API}Admin_SelectAllResponceFromVIEEligibilityByEventID?eventID=${eventID}`);
      const json = await response.json();
      const data = JSON.parse(json)[0];

      if (data && data.ReturnVal === 1) {
        dispatch(slice.actions.Admin_SelectAllResponceFromVIEEligibilityByEventIDSuccess(JSON.parse(data.ReturnData)));
      } else {
        dispatch(slice.actions.hasError(JSON.parse(data.ReturnData)[0].ReturnSqlError));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}